module.exports = __webpack_public_path__ + "static/img/applying_icon.4613650e.png";